<template>
  <div class="header">
    <div class="patient-banner">
      <div class="patient-main-info">
        <h1><i class="fas fa-female"></i> Maternal Profile - ANC Clinic</h1>
        <div class="patient-id-section">
          <span class="patient-id">Patient ID: {{ patient.id }}</span>
          <span class="gestational-age"
            >Gestational Age: {{ patient.gestationalAge }} weeks</span
          >
          <span class="last-visit">Last Visit: {{ patient.lastVisit }}</span>
        </div>
      </div>
    </div>

    <!-- Navigation Tabs -->
    <anc_head />
  </div>
</template>

<script>
import anc_head from "./anc_head.vue";
export default {
  name: "ancheading",
  data() {
    return {
      showEditModal: false,
      patient: {
        id: "ANC-2023-07891",
        fullName: "Sarah Johnson",
        age: 32,
        dateOfBirth: "1991-05-15",
        maritalStatus: "Married",
        education: "Bachelor's Degree",
        occupation: "Teacher",
        husbandName: "Michael Johnson",
        husbandOccupation: "Engineer",
        address: "123 Main Street, Springfield, IL 62704",
        phone: "(555) 123-4567",
        emergencyContact: "(555) 987-6543 (Husband)",
        gestationalAge: 28,
        lastVisit: "2023-11-15",
        ancVisits: 5,
      },
      medicalHistory: {
        conditions: [
          { name: "Hypertension", status: "Controlled", year: 2020 },
          { name: "Asthma", status: "Intermittent", year: 2015 },
          { name: "Anemia", status: "Resolved", year: 2022 },
        ],
        medications: [
          {
            name: "Folic Acid",
            dosage: "400mg daily",
            purpose: "Pregnancy supplement",
          },
          {
            name: "Iron Supplement",
            dosage: "65mg daily",
            purpose: "Anemia prevention",
          },
        ],
        allergies: ["Penicillin", "Sulfa drugs"],
      },
      surgicalHistory: [
        {
          procedure: "Appendectomy",
          year: 2015,
          type: "Emergency",
          hospital: "Springfield General",
          complications: "None",
        },
        {
          procedure: "Cyst Removal",
          year: 2018,
          type: "Elective",
          hospital: "City Medical Center",
          complications: "Minor infection",
        },
        {
          procedure: "Cesarean Section",
          year: 2020,
          type: "Obstetric",
          hospital: "Women's Hospital",
          complications: "Post-operative fever",
        },
      ],
      obstetricHistory: {
        gravida: 3,
        para: 2,
        abortions: 0,
        livingChildren: 2,
        previousPregnancies: [
          {
            year: 2020,
            outcome: "Live Birth",
            gestation: 39,
            birthWeight: "3.2",
            deliveryMode: "Cesarean Section",
            complications: true,
          },
          {
            year: 2022,
            outcome: "Live Birth",
            gestation: 40,
            birthWeight: "3.5",
            deliveryMode: "Vaginal",
            complications: false,
          },
        ],
      },
      familyHistory: {
        Mother: ["Type 2 Diabetes", "Hypertension"],
        Father: ["Heart Disease"],
        Siblings: ["Asthma"],
        "Maternal Grandmother": ["Breast Cancer"],
        "Paternal Grandmother": ["Hypertension"],
      },
      tetanusInjections: {
        completed: 2,
        total: 5,
        doses: [
          { date: "2023-09-01", dose: "TT1", nextDue: "2023-10-01" },
          { date: "2023-10-05", dose: "TT2", nextDue: "2023-11-05" },
        ],
      },
    };
  },
  components: {
    anc_head,
  },
  methods: {
    activeTabChange() {
      this.loading = true;
    },
  },
  mounted() {
    console.log(this.$route.fullPath);
  },
};
</script>

<style scoped>
.header {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 25px;
  overflow: hidden;
}
.patient-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.patient-main-info h1 {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 10px;
}

.patient-main-info h1 i {
  margin-right: 10px;
}
.patient-id-section {
  display: flex;
  gap: 30px;
  font-size: 16px;
}

.patient-id-section span {
  background: rgba(255, 255, 255, 0.2);
  padding: 5px 15px;
  border-radius: 20px;
  font-weight: 600;
}
@media (max-width: 576px) {
  .patient-banner {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .patient-id-section {
    flex-direction: column;
    gap: 10px;
  }

  .gp-score {
    grid-template-columns: 1fr;
  }

  .stats-bar {
    grid-template-columns: 1fr;
  }
}
</style>
